// extracted by mini-css-extract-plugin
export default {"inputSkeleton":"index_inputSkeleton__fsRDY"};